import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const ServiceSidebar = ({ services }) => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMessage('');

        try {
            // Send form data to Formspree
            await axios.post('https://formspree.io/f/mjkvejnb', { email });
            setMessage(t('successMessage'));
            setEmail(''); // Reset email field on success
        } catch (error) {
            setMessage(t('errorMessage'));
            console.error('Newsletter submission error:', error);
        } finally {
            setSubmitting(false);
        }
    };
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="col-lg-4 col-12">
            <div className="blog-sidebar">
                {/* Services Section */}
                <div className="widget category-widget">
                    <h3>{t('serviceSidebar.servicesTitle')}</h3>
                    <ul>
                        {services?.slice(0, 6).map((service, Sitem) => (
                            <li key={Sitem}>
                                <Link
                                    onClick={ClickHandler}
                                    to={`/service-single/${service.slug}`}
                                >
                                    {service?.data?.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Newsletter Section */}
                <div className="wpo-newsletter-widget widget">
                    <h2>{t('serviceSidebar.newsletterTitle')}</h2>

                    <form className="form" onSubmit={handleNewsletterSubmit}>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={t('serviceSidebar.emailPlaceholder')}
                            required
                            aria-label={t('serviceSidebar.emailPlaceholder')}
                        />
                        <button type="submit" disabled={submitting} aria-label={t('serviceSidebar.signUpButton')}>
                            {submitting ? t('submittingButton') : t('serviceSidebar.signUpButton')}
                        </button>
                    </form>
                    {message && <p>{message}</p>}
                    <span>
                        {t('serviceSidebar.privacyNotice')}{' '}
                        <Link to="/privacy">{t('serviceSidebar.privacyPolicy')}</Link>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ServiceSidebar;
